const Contact = () => {
  return (
    <section className="bg-bg-secondary px-[9%] py-[10rem] relative" id="contact">
      {/* Custom Shape Divider Top */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg
          className="relative block w-[calc(146%+1.3px)] h-[89px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" className="fill-bg-primary"></path>
        </svg>
      </div>

      <div className="flex flex-col justify-center items-center relative z-10 pb-[60px]">
        <div className="relative flex justify-center items-center flex-col w-full max-w-[1350px] pt-[40px] gap-3">
          <h2 className="text-[32px] md:text-[42px] text-center font-semibold mt-5 text-white font-rowdies">
            Locate Me
          </h2>
          <p className="text-[16px] md:text-[18px] text-center max-w-[600px] text-white mb-8">
            To Get in Touch with me, Grab the information, forge the connection, and let the good times begin!
          </p>

          <div className="flex items-center justify-between flex-col lg:flex-row w-full gap-8">
            {/* Left Side - Contact Details */}
            <div className="w-full lg:w-1/4 h-full flex flex-col items-center justify-center mt-[15px] relative">
              {/* Vertical Line - Hidden on mobile */}
              <div className="hidden lg:block absolute h-[70%] w-[2px] right-[-15px] top-1/2 -translate-y-1/2 bg-gray-400"></div>

              <div className="m-[14px] text-center">
                <i className="fas fa-map-marker-alt text-[30px] text-purple-700 mb-[10px]"></i>
                <div className="text-[18px] font-medium text-white">
                  <strong>Address</strong>
                </div>
                <div className="text-[14px] text-gray-400">Miyapur</div>
                <div className="text-[14px] text-gray-400">Hyderabad</div>
              </div>

              <div className="m-[14px] text-center">
                <i className="fas fa-phone-alt text-[30px] text-purple-700 mb-[10px]"></i>
                <div className="text-[18px] font-medium text-white">
                  <strong>Phone</strong>
                </div>
                <div className="text-[14px] text-gray-400">+91 7842713943</div>
              </div>

              <div className="m-[14px] text-center">
                <i className="fas fa-envelope text-[30px] text-purple-700 mb-[10px]"></i>
                <div className="text-[18px] font-medium text-white">
                  <strong>Email</strong>
                </div>
                <div className="text-[14px] text-gray-400">sriramgandrothu@gmail.com</div>
                <div className="text-[14px] text-gray-400">swiftprojects14@gmail.com</div>
              </div>
            </div>

            {/* Right Side - Map */}
            <div className="w-full lg:w-3/4 lg:ml-[75px]">
              <div className="text-[18px] font-medium text-white mb-4">
                <i className="fa-solid fa-location-dot"></i>&nbsp;&nbsp;&nbsp;
                <strong>My Location</strong>&nbsp;:
              </div>
              <div className="w-full max-w-[450px] md:max-w-[700px] lg:max-w-[700px]">
                <iframe
                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.9065341713053!2d78.36184867420818!3d17.5119745833966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93c184cef145%3A0x7ee1192efaa4f89c!2sSaptaRishi%20Solutions!5e0!3m2!1sen!2sin!4v1772678033391!5m2!1sen!2sin"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-[200px] md:h-[350px] rounded-lg"
                  title="Map showing our office location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Shape Divider Bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-[calc(170%+1.3px)] h-[54px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M602.45,3.86h0S572.9,116.24,281.94,120H923C632,116.24,602.45,3.86,602.45,3.86Z"
            className="fill-bg-primary"
          ></path>
        </svg>
      </div>
    </section>
  )
}

export default Contact
